
<template>
  <svg
    :width="size"
    :height="size" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <g id="cryptocurrency-03" clip-path="url(#clip0_12604_97355)">
      <path id="Icon" d="M1.5 1.5L3 3M16.5 1.5L15 3M16.5 16.5L15 15M1.5 16.5L3 15M1.5 12H2.625M6 1.5V2.625M16.5 6H15.375M12 16.5V15.375M13.5 12H16.125M12 1.5V4.5M1.5 6H4.5M6 16.5V13.5M12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9C6 7.34315 7.34315 6 9 6C10.6569 6 12 7.34315 12 9Z" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_12604_97355">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  size?: string | number;
  color?: string;
}>(), {
  size: 18,
  color: 'currentColor'
});
</script>